<template>
  <div class="basic_recommend_list_index"
    @mouseenter="module_isHover(true)"
    @mouseleave="module_isHover(false)">
    <div class="tooptipPart module_edit_btn" v-if="isHover">
      <my_hover_btn :tips="$t('widgets_basic_article_classification_index_336')" btnIcon="el-icon-edit" @changeStyle="edit_module"></my_hover_btn>
      <my_hover_btn
        :tips="$t('widgets_basic_article_classification_edit_330')"
        btnIcon="el-icon-magic-stick"
        @changeStyle="animation_set"
        v-if="$store.state.app.view_pattern === 'pc'"
      ></my_hover_btn>
      
      <my_close_btn :module="module" :column="column" :moduleIndex="module_index"
                    v-if="$store.state.app.view_pattern === 'pc'"></my_close_btn>
    </div>
    <div class="basic_recommend_list">
      <my_title_index :title="widgets_infor.title"></my_title_index>
      <div class="module_wrap" :class="'module_wrap_' + listArr.module_style">
        <div class="empty" v-if="list.length == 0">
          <selection_prompt type="recommendList" select-type="list"></selection_prompt>
          <!-- <el-popover placement="top" width="200">
                <p>请选择添加的文章类型</p>
                <div style="text-align: right; margin: 0">
                  <el-button
                    size="mini"
                    type="text"
                    @click="selectType(item.value)"
                    v-for="(item, i) in filter.typeOptions"
                    :key="i"
                  >{{ item.label }}
                  </el-button
                  >
                </div>
                <el-button type="primary" size="small" slot="reference"
                >添加文章
                </el-button
                >
              </el-popover> -->
        </div>
        <div class="module_content" v-loading="loading" v-if="list.length > 0">
          <!-- 第一种模式 -->
          <template v-if="[0, 2, 3].includes(listArr.module_style)">
            <div :class="[`product_list_${listArr.module_style}`]">
              <one_img
                v-for="(item,i) in list"
                :key="i"
                :item="item"
                :module="module"
                :hideBtn="hideBtn"
              ></one_img>
            </div>
          </template>
          <!-- 第二种轮播图模式 -->
          <template v-if="listArr.module_style == 1">
            <!-- pc模式 -->
            <template v-if="$store.state.app.view_pattern === 'pc'">
              <div class="product_list_1">
                <swiper
                  ref="mySwiper"
                  class="list_box"
                  :options="swiperOption"
                  v-if="$store.state.app.basic_pro_display_isRender"
                >
                  <swiper-slide v-for="(item,i) in list" :key="i">
                    <one_img
                      :item="item"
                      :module="module"
                      :hideBtn="hideBtn"
                      type="swiper"
                    ></one_img>
                  </swiper-slide>
                </swiper>

                <template v-if="$store.state.app.view_pattern === 'pc'">
                  <div class="arrow prev" @click="swiper_prev"></div>
                  <div class="arrow next" @click="swiper_next"></div>
                </template>
              </div>
            </template>

            <template v-else>
              <div class="list_box flex_box mb_swiper_list">
                <one_img
                  v-for="(item,i) in list"
                  :key="i"
                  :item="item"
                  :module="module"
                  :hideBtn="hideBtn"
                ></one_img>
              </div>
            </template>
          </template>
          
        </div>
      </div>

    </div>
  </div>
</template>

<script type="text/javascript">
import i18n from '../../language/index'

import selection_prompt from '@/components/selection_prompt';
import one_img from './components/one_img';
import {getRecommendList} from '@/api/app'
export default {
  name: 'basic_recommend_list_index',
  data(){
    return{
      isHover: false,
      list:[],
      loading: false,
      hideBtn: false,
      filter: {  //1:新闻 2:帮助 3:案例 4:下载 5:图册 11:视频
        typeOptions: [
          {
            label: i18n.t('widgets_basic_classification_edit_482'),
            value:0
          },
          {
            label: i18n.t('widgets_basic_article_classification_edit_333'),
            value: 1,
          },
          {
            label: i18n.t('widgets_basic_article_classification_edit_334'),
            value: 3,
          },
          {
            label: i18n.t('widgets_basic_article_classification_edit_335'),
            value: 2,
          },
          {
            label: i18n.t('view_download_index_181'),
            value:11,
          }
        ],
      },
    }
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // this.templet.get_product(this);
    this.getRecommendList(); // 热门推荐
  },
  computed: {
    listArr() {
      return this.module.data.listArr
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor
    },
    widgets_infor() {
      return this.module.data[this.$store.state.app.view_pattern + "_widgets_infor"];
    },
    swiperOption() {
      const infor = this.module.data.pc_widgets_infor;
      const num = parseInt(infor.col_num[infor.col_num.radio_val].value);
      const slidesPerGroup = parseInt(infor.slides_group[infor.slides_group.radio_val].value);
      const loop = infor.swiper_loop === 'true' ? true : false
      const obj = {
        myVm: this,
        loop: slidesPerGroup == 1 ? loop : false,
        direction: "horizontal",
        slidesPerView: num,
        slidesPerGroup,//每次翻页个数
        observer: true,
        observeParents: true,
      }
      const autoplay = this.templet.autoplay_obj(
        infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    
  },
  methods: {
    /* 是否显示tooptipPart*/
    module_isHover(val) {
      this.isHover = val;
    },
     /* 编辑模块*/
    edit_module() {
      this.templet.changeStyle(this.module, 'style');
    },
    /* 动画设置*/
    animation_set() {
      this.templet.changeStyle(this.module, 'animation');
    },
    /* 删除模块*/
    del_module() {
      this.templet.del_module(this.column.widgets_id, this.module_index, this.module.data.anchor_id);
    },
    getProduct() {
      this.templet.get_product(this);
    },
    /* 上一个*/
    swiper_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    /* 下一个*/
    swiper_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    async getRecommendList() { // 获取热门推荐列表
      if(this.listArr.types.length === 0 ) {
        this.list = [];
        return;
      }
      let params = {
        id: this.$route.query.id,
        dataType: this.$route.name === 'product' ? 1 : 2, // 产品或文章：1产品，2文章
        types: this.listArr.types.join(','),
        limit:this.widgets_infor.recommend_num, // 推荐个数
      };
      let res = await getRecommendList(params);
      if(res.code === 200){
       
        this.list= res.data
      }
    }
  },
  watch: {
    'listArr.types'() {
      this.getRecommendList()
    },
    'widgets_infor.recommend_num'() {
      this.getRecommendList()
    }
  },
  components: {
    selection_prompt,
    one_img
  }
};
</script>

<style scoped lang="scss">
.basic_recommend_list_index{
  position: relative;
  box-sizing: border-box;
  min-height: 30px;
  min-width: 30px;
  height: 100%;

  .tooptipPart {
    right: 0;
    top: 0;
    display: block;
    z-index: 999;
  }
  .basic_recommend_list{
    .module_wrap {
      .module_content {
        position: relative;
        font-size: 14px;

        .product_list_0 {
          display: flex;
          flex-wrap: wrap;
          align-items: stretch;

          /deep/ .list_one {
            height: auto !important;
          }
        }

        .product_list_2 {                   
          /deep/ .list_one {
            width: calc(100% - 20px);
            padding: 20px;
            // margin: 20px 10px;
            margin: 10px 0;
            overflow: visible;
            display: flex;

            &:not(:last-child):after {
              content: "";
              width: 100%;
              height: 0;
              border-bottom: 1px dashed #f0f0f0;
              display: block;
              position: absolute;
              bottom: -6px;
              left: 0;
            }

            .list_content_frame {
              float: left;
              margin-left: 20px;
              width: calc(75% - 20px);
              text-align: left;
            }
          }

          /deep/ .list_img_frame {
            width: 25%;
            padding-bottom: 25%;
            float: left;
          }

          /deep/ .list_one_wrap {
            display: block;
            height: 100%;
            color: #333;
            // padding: 0;
            padding: 10px 10px;
            overflow: visible;
          }
        }

        .product_list_3 {
          /deep/ .list_one {
            text-align: left;
            border: 1px solid #f0f0f0;
            border-radius: 2px;
            transition: none;
            padding: 0;
            .list_one_wrap {
              position: relative;
              transition: 0.5s;

              .product_name_wrap {
                margin-bottom: 0 !important;
                margin-top: 0 !important;

                .product_name {
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  overflow: hidden;
                  display: inline-block;
                  max-width: 100%;
                }
              }
            }

            /deep/ .list_img_frame {
              display: none;
            }
          }
        }

        .product_list_1 {
          padding: 0 60px;
          position: relative;

          .list_box {
            .swiper-wrapper {
              .swiper-slide {
                height: auto;

                .list_one {
                  height: 100%;
                  padding: 10px;
                  margin: 0 !important;
                  width: 100% !important;
                }
              }
            }
          }

          .arrow {
            cursor: pointer;
            display: block;
            width: 40px;
            height: 40px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
            position: absolute;
            z-index: 99;
            top: 50%;
            transform: translateY(-50%);
            background: rgba(0, 0, 0, 0.2);
            transition: background 0.15s;
            outline: 0;
          }

          .arrow:before {
            content: "";
            position: absolute;
            display: block;
            width: 10px;
            height: 18px;
            background: url("/static/image/backimg1.png") -23px -268px;
            top: 50%;
            left: 50%;
            transform: translate(-50%) translateY(-50%);
          }

          .prev {
            left: 10px;
          }

          .next {
            right: 10px;
          }

          .next:before {
            background-position-x: -53px;
            left: 54%;
          }
        }
      }
    }
  }
}

.mb_pattern {
  .module_wrap_0, .module_wrap_1 {
    padding-top: 28px;
  }

  .module_wrap_1 {
    padding-top: 18px;
  }
}
.mb_pattern {
  .basic_recommend_list_index {
    .product_list_0,
    .product_list_1,
    .product_list_2,
    .mb_swiper_list {
      padding: 0 1.8%;
      width: auto;
    }
  }
}

.mb_pattern {
  .basic_recommend_list_index .basic_recommend_list .module_wrap .module_content{
    /deep/ .list_content_frame {
      text-align: left;
      margin: 6px;

      .product_name_wrap {
        margin-top: 0 !important;
        margin-bottom: 5px !important;

        .product_name {
          // font-size: 14px !important;
        }
      }
    }

    .mb_swiper_list {
      width: 100%;
      display: block;
      overflow-x: auto;
      white-space: nowrap;

      /deep/ .list_one {
        width: 45%;
        text-align: left;
        padding: 10px;
        margin: 0 !important;

        .list_one_wrap {
          padding: 0;
        }
      }
    }

    .mb_swiper_list::-webkit-scrollbar {
      height: 0px;
    }

    .product_list_0 {
      /deep/ .list_one_wrap {
        padding: 0;
      }
    }

    .product_list_2 {
      /deep/ .list_one {
        padding: 0;
        margin: 10px;
        overflow: visible;
        box-sizing: content-box;

        .list_img_frame {
          width: 33.8%;
          padding-bottom: 33.8%;
          float: left;
        }

        .product_name_wrap {
          margin: 6px !important;
        }

        .list_content_frame {
          width: 66.2%;
          display: inline-block;
          float: none;
          margin: 0;
          box-sizing: border-box;
          padding-left: 12px;
        }
      }
    }

    .product_list_3 {
      margin-top: 0;

      /deep/ .list_one {
        text-align: left;
        width: 100%;
        border: none;
        margin: 0;
        padding: 15px;
        border-bottom: 1px solid #f1f1f1;

        .list_one_wrap {
          padding: 0;
        }

        .list_content_frame {
          margin: 0;
        }
      }
    }
  }
}

.mb_pattern .module_wrap_2 {
  padding-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_recommend_list/index.vue